<template>
    <div class="">
        <div class="">
            <div class="mr-2 mb-2">
                <div class="card-body py-3">
                    <div v-if="status">
                        <div class="d-flex justify-content-between align-items-center py-1 pl-2 mb-2 pr-2 rounded" style="background-color: #f8f9fa !important;">
                            <a
                                :href="mapUrl"
                                target="_blank"
                                rel="noopener"
                                class="text-md text-truncate"
                                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                            >{{ isRedirectParcelMap ? parcelMapUrl : mapUrl }}</a>
                            <div class="position-relative">
                                <button
                                    class="btn btn-sm text-secondary ml-auto"
                                    @click="copyToClipboard"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#c0c0c0"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>
                                </button>
                                <span v-if="copySuccess" class="copy-tooltip small text-muted">Copied!</span>
                            </div>
                        </div>
                    </div>
                    <div class="row flex">
                        <div class="mt-1 ml-2 mr-3" v-if="isAdminOrMember">
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    v-model="status"
                                >
                                <label
                                    class="custom-control-label"
                                    data-toggle="modal"
                                    data-target="#confirmModal"
                                >{{ trans.status_val[statusNum] }}</label>
                            </div>
                            <small class="form-text text-muted" v-if="isRedirectParcelMap">
                                {{ trans.redirect_floor_map }}
                            </small>
                        </div>
                        <div
                            class="ml-auto"
                        >
                            <span v-if="status">
                            <a
                                :href="isRedirectParcelMap ? parcelMapUrl : mapUrl"
                                target="”_blank”"
                                rel="noopener"
                                class="btn btn-primary btn-sm"
                            >{{ trans.public_url }}</a>
                            <a
                                href="#shareModal"
                                data-toggle="modal"
                                class="btn btn-sm btn-outline-secondary ml-1"
                            >
                                Iframe
                            </a>
                            </span>
                            <a
                                href="./preview"
                                target="_blank"
                                rel="noopener"
                                class="btn btn-warning btn-sm ml-1"
                            >Preview</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            id="shareModal"
            role="dialog"
            v-if="status"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content rounded">
                    <div class="modal-header">
                        <h4 class="modal-title ml-3 text-lg">iframe</h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mt-2 col-sm-12">
                            <div class="my-2">
                                <div>
                                    <div class="form-group row">
                                        <p class="callout ml-3 mr-2 elevation-1">{{ trans.iframe_explanation }}</p>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 col-form-label text-sm-center font-weight-light">URL</label>
                                        <div class="col-sm-10">
                                            <div class="input-group">
                                                <input
                                                    class="form-control"
                                                    type="text"
                                                    readonly
                                                    :value="mapUrl"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 col-form-label text-sm-center font-weight-light">iframe</label>
                                        <div class="col-sm-10">
                                            <div class="input-group">
                                                <textarea
                                                    class="form-control"
                                                    id="exampleFormControlTextarea1"
                                                    rows="3"
                                                    :value="iframeString"
                                                    readonly
                                                    style="height: 460px;"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="confirmModal"
            tabindex="0"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5
                            class="modal-title"
                            id="exampleModalLabel"
                        >{{ trans.confirmation }}</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ trans.confirmation_change_status }}
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >{{ trans.close }}</button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="changeStatus"
                        >{{ trans.update }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
        mapUrl: {
            type: String,
            required: true,
        },
        mapStatus: {
            type: Boolean,
            required: true,
        },
        updateStatusRoute: {
            type: String,
            required: true,
        },
        isAdminOrMember: {
            type: Boolean,
            default: false,
        },
        parcelMapUrl: {
            type: String,
            required: true,
        },
        isRedirectParcelMap: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            status: this.mapStatus,
            copySuccess: false,
        };
    },
    computed: {
        iframeString() {
        return (
            '<!--\n' +
            '    Iframe embed code\n' +
            '    - frameborder: 0 - No border\n' +
            '    - allow: geolocation - Allows access to location information\n' +
            '    - overflow: hidden - No scrollbars\n' +
            '    - z-index: 1 - Displays above other elements\n' +
            '    - allowfullscreen, mozallowfullscreen, webkitallowfullscreen - Allows fullscreen mode\n' +
            '-->\n' +
            '<iframe src="' + this.mapUrl + '"\n' +
            '  frameborder="0"\n' +
            '  allow="geolocation"\n' +
            '  style="width: 100%; height: 600px; border: none; overflow: hidden; z-index: 1;"\n' +
            '  allowfullscreen="true"\n' +
            '  mozallowfullscreen="true"\n' +
            '  webkitallowfullscreen="true">\n' +
            '</iframe>'
        );
    },
        statusNum() {
            return this.status ? 1 : 0;
        },
    },
    methods: {
        changeStatus() {
            var self = this;
            axios({
                method: "PUT",
                url: this.updateStatusRoute,
                data: {
                    status: !this.status,
                },
            })
                .then((response) => {
                    self.status = !this.status;
                    $('#confirmModal').modal('hide')
                })
                .catch((error) => {
                    alert("Can't update status");
                    location.reload();
                });
        },
        copyToClipboard() {
            const text = this.mapUrl;
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.setAttribute("readonly", "");
            textarea.style.position = "absolute";
            textarea.style.left = "-9999px";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.copySuccess = true;
            setTimeout(() => {
                this.copySuccess = false;
            }, 1000);
        }
    },
};
</script>

<style>
</style>